module.exports = __webpack_public_path__ + "static/media/icon-withdraw-with-border.241ed288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-withdraw-with-border.svg
// module id = 1231
// module chunks = 19